module.exports = __webpack_public_path__ + "img/james-cox.01929bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/james-cox.png
// module id = 130
// module chunks = 0